import React, { useContext } from 'react'
import { FormattedMessage, FormattedPlural, useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import classNames from 'classnames'
import { ContractsModel, ContractsOmission } from '../../../types/contracts/contractsModel'
import { formatDate } from '../../../utils/formatDate'
import { ASSURANCE_CONCERN } from '../../requests/makeRequest/stepper/Stepper'
import { MakeRequestContext } from '../../requests/makeRequest/MakeRequestContext'

const useStyle = makeStyles(
	(theme) => styles(theme)
)

interface AcceptingProps {
	color?: string
	contract: Omit<ContractsModel, ContractsOmission>
	text?: string
}

type ContractDetailsProps = AcceptingProps

const ContractDetails: React.FC<ContractDetailsProps> = (
	{
		contract,
		color,
		text
	}
) => {
	const classes = useStyle()
	const intl = useIntl()
	const { request } = useContext(MakeRequestContext)

	const cardDescriptionClass = classNames(
		classes[color as keyof typeof classes],
		{
			[classes.text3_opacity]: !text,
			[classes[text as keyof typeof styles]]: text
		}
	)

	return (
		<>
			<span className={cardDescriptionClass}>
				<FormattedMessage
					id="dashboard.contracts.lease"
					defaultMessage="Bail n°"
					description="Dashboard contract lease text"
					values={
						{
							lease: contract.lease
						}
					}
				/>

				<FormattedPlural
					value={contract.lots.length}
					one="lot "
					other="lots "
				/>

				{
					contract.lots.map(
						(lot, index) => (
							<span key={index}>
								n°{lot}{index === contract.lots.length - 1 ? '' : ', '}
							</span>
						)
					)
				}
			</span>

			<br />

			<span className={cardDescriptionClass}>
				{contract.buildings && contract.buildings.length > 0 ? contract.buildings[0].address : contract.address}
			</span>

			<br />

			<span className={cardDescriptionClass}>
				{contract.buildings && contract.buildings.length > 0 ? contract.buildings[0].postalCode : contract.postalCode}, {contract.buildings && contract.buildings.length > 0 ? contract.buildings[0].city : contract.city}
			</span>
			<br />

			{request.requestConcern === ASSURANCE_CONCERN && contract.dateFinAssurance &&
				<span className={cardDescriptionClass}>
					<FormattedMessage
						id="requests.makeRequest.step4.assurance.dateFin.echeance"
						defaultMessage="Date fin de l’assurance : "
						description="Echeance Date text"
					/>
					{formatDate(contract.dateFinAssurance, intl.locale)}
				</span>
			}
		</>
	)
}

export default ContractDetails
